import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";

class ShiftsDataService {
  getAllShifts = () => {
    return getDocs(collection(db, "Shifts"));
  };
}
export default new ShiftsDataService();
